import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function phoneNumberValidator(formControl: AbstractControl, field: FormlyFieldConfig): ValidationErrors | null  {
  const phoneNumberPattern = /^[\d+()\-\s]+$/;
  let phoneNumberRegex = /\(\d{3}\) \d{3}-\d{4}/; 
  let model = formControl.value;
  if (phoneNumberRegex.test(formControl.value)) {
    return null;
  }
  if(model){
  let formatPhoneNumber = model?.replace(/\D/g, '');
  if ( !phoneNumberPattern.test(formControl.value) || formatPhoneNumber.length != 10) {
    formControl.markAsTouched();
    return {
      'phone-number-validator': {
        message: 'Please enter phone number as ×××-×××-××××.',
      },
    };
  }
  let contactNumber = ''; 
  if (!phoneNumberRegex.test(formatPhoneNumber)) {
    if (formatPhoneNumber.length >= 3) {
      contactNumber += `(${formatPhoneNumber.slice(0, 3)}`;
      if (formatPhoneNumber.length >= 6) {
        contactNumber += `) ${formatPhoneNumber.slice(3, 6)}`;
        if (formatPhoneNumber.length >= 8) {
          contactNumber += `-${formatPhoneNumber.slice(6, 8)}`;
          if (formatPhoneNumber.length >= 10) {
            contactNumber += `${formatPhoneNumber.slice(8, 10)}`;
          }
        }
      }
    }
    const check = contactNumber.replace(/\D/g, '');
    formatPhoneNumber = contactNumber;
    if (check.length === 10) {
      formControl.patchValue(contactNumber);
      return null;
    }
  }
}
  return null;
}
